import type { Percentage} from "@towni/common";
import { percentageToHuman } from "@towni/common";
import type { Except } from "type-fest";
import type { TextBoxProps } from "./text-box";
import { TextBox } from "./text-box";

type Props = {
    value: Percentage | number | undefined;
    /**
     * fallback text to show if value is undefined \
     * defaults to `"0"`
     * @type {string}
     */
} & Except<TextBoxProps, "text" | "children">;

const PercentageTextBox = (props: Props) => {
    const { value, ...passOnProps } = props;
    const formatted = percentageToHuman((value ?? 0) as Percentage);
    return <TextBox text={formatted} {...passOnProps} />;
};

export { PercentageTextBox };
